export function FolioSelector({ options, value, onChange }) {
  if (!options) return null;
  const missing = options.missing || [];
  const nextNum = options.next?.number || "";
  return (
    <div className="border border-[#465B7F]/30 bg-[#465B7F]/5 p-3" data-testid="folio-selector">
      <span className="overline block mb-1.5">Folio a asignar</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid="folio-select"
        className="w-full bg-white border border-[#E3E8EE] px-3 py-2 font-mono-data text-sm text-[#16202B] focus:outline-none focus:ring-1 focus:ring-[#465B7F]"
      >
        <option value="">Siguiente consecutivo — {nextNum}</option>
        {missing.map((m) => (
          <option key={m.seq} value={m.number}>{m.number} · folio faltante</option>
        ))}
      </select>
      {missing.length > 0 && (
        <p className="font-mono-data text-xs text-[#7A5A08] bg-[#FBF3DA] border border-[#E0A93B]/40 px-2.5 py-2 mt-2" data-testid="folio-missing-note">
          Hay {missing.length} folio(s) faltante(s) en la secuencia: {missing.map((m) => m.number).join(", ")}. Puedes reutilizar uno o dejar el siguiente consecutivo.
        </p>
      )}
    </div>
  );
}
